class StoreImages {
  constructor() {
    this.images = [];
    this.id = null;
    this.toggleModal = () => {};
    this.setSelectedImage = () => {};
  }

  resetImages() {
    this.images = [];
  }

  removeDuplicated = (images, key) => {
    this.images = images
      .map(item => item[key])
      .map((item, index, final) => final.indexOf(item) === index && index)
      .filter(item => images[item])
      .map(item => images[item]);
  };

  handleSelectedImage = imageId => {
    const index = this.images.findIndex(image => image.imageId === imageId);
    if (index !== -1) {
      this.setSelectedImage(index);
    }
  };

  setHandlers = ({ toggleModal = this.toggleModal, setSelectedImage = this.setSelectedImage }) => {
    this.toggleModal = toggleModal;
    this.setSelectedImage = setSelectedImage;
  };

  addImages = (images, options = {}) => {
    if (!images.length) return this.images;

    const { pageBuilderID } = options;

    if (pageBuilderID !== this.id) {
      this.resetImages();
      this.id = pageBuilderID;
    }

    this.removeDuplicated(this.images.concat(images), 'imageId');

    return this.images;
  };
}

export default new StoreImages();
